<template>
    <div class="billing-details">
        <!-- <h3>{{ $t('common.microcopy.number_of') }} {{ getLabelType }}: {{ numberOfItems }}</h3> -->
        <div v-for="(msg, index) in priceMessages" :key="index">
            <p>
                {{ msg.message }}
            </p>
        </div>
    </div>
</template>

<script>
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    export default {
        props: {
            numberOfItems: {
                type: Number,
                required: true,
            },
            isAnnual: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            pricePerItem() {
                if (this.$auth.getPractice().practiceType === PracticeTypeEnum.ANCILLARY) {
                    return this.isAnnual
                        ? process.env.VUE_APP_PRICE_PER_ANCILLARY_LOCATION_ANNUALLY_SUB * 12
                        : process.env.VUE_APP_PRICE_PER_ANCILLARY_LOCATION_MONTHLY_SUB
                }
                return this.isAnnual
                    ? process.env.VUE_APP_PRICE_PER_PHYSICIAN_ANNUALLY_SUB * 12
                    : process.env.VUE_APP_PRICE_PER_PHYSICIAN_MONTHLY_SUB
            },

            getLabelType() {
                return this.$auth.getPractice().practiceType === PracticeTypeEnum.ANCILLARY
                    ? this.$t('common.microcopy.locations')
                    : this.$t('common.microcopy.providers')
            },

            priceMessages() {
                let messages = []
                const numberOfItems = this.numberOfItems

                if (numberOfItems <= 3) {
                    messages.push({
                        message: `You have ${numberOfItems} provider${numberOfItems === 1 ? '' : 's'} billed at full price`,
                        price: `${numberOfItems} x $${this.pricePerItem}`,
                    })
                } else if (numberOfItems <= 12) {
                    messages.push({
                        message: `You have 3 providers billed at full price and`,
                        price: `3 x $${this.pricePerItem}`,
                    })
                    const discountedItems = numberOfItems - 3
                    messages.push({
                        message: `${numberOfItems - 3} provider${numberOfItems - 3 === 1 ? '' : 's'} billed at 50%`,
                        price: `${discountedItems} x $${this.pricePerItem / 2}`,
                    })
                } else {
                    messages.push({
                        message: `You have 3 providers billed at full price,`,
                        price: `3 x $${this.pricePerItem}`,
                    })
                    messages.push({
                        message: `9 providers billed at 50% and`,
                        price: `9 x $${this.pricePerItem / 2}`,
                    })
                    const discountedItems = numberOfItems - 12
                    messages.push({
                        message: `${numberOfItems - 12} provider${numberOfItems - 12 === 1 ? '' : 's'} billed at 25% price`,
                        price: `${discountedItems} x $${this.pricePerItem / 4}`,
                    })
                }

                return messages
            },
        },
    }
</script>

<style lang="scss">
    .billing-details {
        margin-top: 30px;
    }
</style>
